/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAnimations } from '../fn/restaurants/get-animations';
import { GetAnimations$Params } from '../fn/restaurants/get-animations';
import { getAnimationsByAnimationidImage } from '../fn/restaurants/get-animations-by-animationid-image';
import { GetAnimationsByAnimationidImage$Params } from '../fn/restaurants/get-animations-by-animationid-image';
import { getAnimationsByAnimationidPictogram } from '../fn/restaurants/get-animations-by-animationid-pictogram';
import { GetAnimationsByAnimationidPictogram$Params } from '../fn/restaurants/get-animations-by-animationid-pictogram';
import { GetAnimationsResult } from '../models/get-animations-result';
import { getByRestaurantidCurrentfluidite } from '../fn/restaurants/get-by-restaurantid-currentfluidite';
import { GetByRestaurantidCurrentfluidite$Params } from '../fn/restaurants/get-by-restaurantid-currentfluidite';
import { getByRestaurantidFluiditerates } from '../fn/restaurants/get-by-restaurantid-fluiditerates';
import { GetByRestaurantidFluiditerates$Params } from '../fn/restaurants/get-by-restaurantid-fluiditerates';
import { getByRestaurantidHomeRedirection } from '../fn/restaurants/get-by-restaurantid-home-redirection';
import { GetByRestaurantidHomeRedirection$Params } from '../fn/restaurants/get-by-restaurantid-home-redirection';
import { getByRestaurantidImage } from '../fn/restaurants/get-by-restaurantid-image';
import { GetByRestaurantidImage$Params } from '../fn/restaurants/get-by-restaurantid-image';
import { getByRestaurantidMenus } from '../fn/restaurants/get-by-restaurantid-menus';
import { GetByRestaurantidMenus$Params } from '../fn/restaurants/get-by-restaurantid-menus';
import { GetCurrentFluiditeResult } from '../models/get-current-fluidite-result';
import { GetExternalRestaurantHomeResult } from '../models/get-external-restaurant-home-result';
import { GetFluiditeRatesResult } from '../models/get-fluidite-rates-result';
import { getFormulesByFormuleidImage } from '../fn/restaurants/get-formules-by-formuleid-image';
import { GetFormulesByFormuleidImage$Params } from '../fn/restaurants/get-formules-by-formuleid-image';
import { getFormulesByFormuleidThumbnail } from '../fn/restaurants/get-formules-by-formuleid-thumbnail';
import { GetFormulesByFormuleidThumbnail$Params } from '../fn/restaurants/get-formules-by-formuleid-thumbnail';
import { GetRestaurantMenusResult } from '../models/get-restaurant-menus-result';
import { getRestaurants } from '../fn/restaurants/get-restaurants';
import { GetRestaurants$Params } from '../fn/restaurants/get-restaurants';
import { GetRestaurantsResult } from '../models/get-restaurants-result';
import { patchDishByDishidLikes } from '../fn/restaurants/patch-dish-by-dishid-likes';
import { PatchDishByDishidLikes$Params } from '../fn/restaurants/patch-dish-by-dishid-likes';

@Injectable({ providedIn: 'root' })
export class ApiRestaurantsService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRestaurantsAnimationsByAnimationidImage()` */
  static readonly GetRestaurantsAnimationsByAnimationidImagePath = '/Restaurants/animations/{AnimationId}/image';

  /**
   * get-restaurants-animations-by-animationid-image.
   *
   * Get animation image by animation id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAnimationsByAnimationidImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnimationsByAnimationidImage$Response(params: GetAnimationsByAnimationidImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getAnimationsByAnimationidImage(this.http, this.rootUrl, params, context);
  }

  /**
   * get-restaurants-animations-by-animationid-image.
   *
   * Get animation image by animation id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAnimationsByAnimationidImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnimationsByAnimationidImage(params: GetAnimationsByAnimationidImage$Params, context?: HttpContext): Observable<void> {
    return this.getAnimationsByAnimationidImage$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `getRestaurantsAnimationsByAnimationidPictogram()` */
  static readonly GetRestaurantsAnimationsByAnimationidPictogramPath = '/Restaurants/animations/{AnimationId}/pictogram';

  /**
   * get-restaurants-animations-by-animationid-pictogram.
   *
   * Get animation pictogram by animation id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAnimationsByAnimationidPictogram()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnimationsByAnimationidPictogram$Response(
    params: GetAnimationsByAnimationidPictogram$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    return getAnimationsByAnimationidPictogram(this.http, this.rootUrl, params, context);
  }

  /**
   * get-restaurants-animations-by-animationid-pictogram.
   *
   * Get animation pictogram by animation id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAnimationsByAnimationidPictogram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnimationsByAnimationidPictogram(params: GetAnimationsByAnimationidPictogram$Params, context?: HttpContext): Observable<void> {
    return this.getAnimationsByAnimationidPictogram$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `getRestaurantsAnimations()` */
  static readonly GetRestaurantsAnimationsPath = '/Restaurants/animations';

  /**
   * get-restaurants-animations.
   *
   * Get animations<br>Get the list of animations for a site
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAnimations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnimations$Response(params?: GetAnimations$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAnimationsResult>> {
    return getAnimations(this.http, this.rootUrl, params, context);
  }

  /**
   * get-restaurants-animations.
   *
   * Get animations<br>Get the list of animations for a site
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAnimations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnimations(params?: GetAnimations$Params, context?: HttpContext): Observable<GetAnimationsResult> {
    return this.getAnimations$Response(params, context).pipe(map((r: StrictHttpResponse<GetAnimationsResult>): GetAnimationsResult => r.body));
  }

  /** Path part for operation `getRestaurantsByRestaurantidCurrentfluidite()` */
  static readonly GetRestaurantsByRestaurantidCurrentfluiditePath = '/Restaurants/{RestaurantId}/currentFluidite';

  /**
   * get-restaurants-by-restaurantid-currentfluidite.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByRestaurantidCurrentfluidite()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByRestaurantidCurrentfluidite$Response(
    params: GetByRestaurantidCurrentfluidite$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<GetCurrentFluiditeResult>> {
    return getByRestaurantidCurrentfluidite(this.http, this.rootUrl, params, context);
  }

  /**
   * get-restaurants-by-restaurantid-currentfluidite.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByRestaurantidCurrentfluidite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByRestaurantidCurrentfluidite(params: GetByRestaurantidCurrentfluidite$Params, context?: HttpContext): Observable<GetCurrentFluiditeResult> {
    return this.getByRestaurantidCurrentfluidite$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetCurrentFluiditeResult>): GetCurrentFluiditeResult => r.body),
    );
  }

  /** Path part for operation `getRestaurantsByRestaurantidHomeRedirection()` */
  static readonly GetRestaurantsByRestaurantidHomeRedirectionPath = '/Restaurants/{RestaurantId}/home-redirection';

  /**
   * get-restaurants-by-restaurantid-home-redirection.
   *
   * Get Home information for an external restaurant<br>Get all informations to go to the Home for an external restaurant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByRestaurantidHomeRedirection()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByRestaurantidHomeRedirection$Response(
    params: GetByRestaurantidHomeRedirection$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<GetExternalRestaurantHomeResult>> {
    return getByRestaurantidHomeRedirection(this.http, this.rootUrl, params, context);
  }

  /**
   * get-restaurants-by-restaurantid-home-redirection.
   *
   * Get Home information for an external restaurant<br>Get all informations to go to the Home for an external restaurant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByRestaurantidHomeRedirection$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByRestaurantidHomeRedirection(params: GetByRestaurantidHomeRedirection$Params, context?: HttpContext): Observable<GetExternalRestaurantHomeResult> {
    return this.getByRestaurantidHomeRedirection$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetExternalRestaurantHomeResult>): GetExternalRestaurantHomeResult => r.body),
    );
  }

  /** Path part for operation `getRestaurantsByRestaurantidFluiditerates()` */
  static readonly GetRestaurantsByRestaurantidFluiditeratesPath = '/Restaurants/{RestaurantId}/fluiditeRates';

  /**
   * get-restaurants-by-restaurantid-fluiditerates.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByRestaurantidFluiditerates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByRestaurantidFluiditerates$Response(
    params: GetByRestaurantidFluiditerates$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<GetFluiditeRatesResult>> {
    return getByRestaurantidFluiditerates(this.http, this.rootUrl, params, context);
  }

  /**
   * get-restaurants-by-restaurantid-fluiditerates.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByRestaurantidFluiditerates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByRestaurantidFluiditerates(params: GetByRestaurantidFluiditerates$Params, context?: HttpContext): Observable<GetFluiditeRatesResult> {
    return this.getByRestaurantidFluiditerates$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetFluiditeRatesResult>): GetFluiditeRatesResult => r.body),
    );
  }

  /** Path part for operation `getRestaurantsFormulesByFormuleidImage()` */
  static readonly GetRestaurantsFormulesByFormuleidImagePath = '/Restaurants/formules/{FormuleId}/image';

  /**
   * get-restaurants-formules-by-formuleid-image.
   *
   * Get formule image by formule id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFormulesByFormuleidImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormulesByFormuleidImage$Response(params: GetFormulesByFormuleidImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getFormulesByFormuleidImage(this.http, this.rootUrl, params, context);
  }

  /**
   * get-restaurants-formules-by-formuleid-image.
   *
   * Get formule image by formule id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFormulesByFormuleidImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormulesByFormuleidImage(params: GetFormulesByFormuleidImage$Params, context?: HttpContext): Observable<void> {
    return this.getFormulesByFormuleidImage$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `getRestaurantsFormulesByFormuleidThumbnail()` */
  static readonly GetRestaurantsFormulesByFormuleidThumbnailPath = '/Restaurants/formules/{FormuleId}/thumbnail';

  /**
   * get-restaurants-formules-by-formuleid-thumbnail.
   *
   * Get formule thumbnail by formule id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFormulesByFormuleidThumbnail()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormulesByFormuleidThumbnail$Response(params: GetFormulesByFormuleidThumbnail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getFormulesByFormuleidThumbnail(this.http, this.rootUrl, params, context);
  }

  /**
   * get-restaurants-formules-by-formuleid-thumbnail.
   *
   * Get formule thumbnail by formule id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFormulesByFormuleidThumbnail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormulesByFormuleidThumbnail(params: GetFormulesByFormuleidThumbnail$Params, context?: HttpContext): Observable<void> {
    return this.getFormulesByFormuleidThumbnail$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `getRestaurantsByRestaurantidImage()` */
  static readonly GetRestaurantsByRestaurantidImagePath = '/Restaurants/{RestaurantId}/image';

  /**
   * get-restaurants-by-restaurantid-image.
   *
   * Get restaurant image by restaurant id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByRestaurantidImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByRestaurantidImage$Response(params: GetByRestaurantidImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getByRestaurantidImage(this.http, this.rootUrl, params, context);
  }

  /**
   * get-restaurants-by-restaurantid-image.
   *
   * Get restaurant image by restaurant id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByRestaurantidImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByRestaurantidImage(params: GetByRestaurantidImage$Params, context?: HttpContext): Observable<void> {
    return this.getByRestaurantidImage$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `getRestaurantsByRestaurantidMenus()` */
  static readonly GetRestaurantsByRestaurantidMenusPath = '/Restaurants/{RestaurantId}/menus';

  /**
   * get-restaurants-by-restaurantid-menus.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByRestaurantidMenus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByRestaurantidMenus$Response(params: GetByRestaurantidMenus$Params, context?: HttpContext): Observable<StrictHttpResponse<GetRestaurantMenusResult>> {
    return getByRestaurantidMenus(this.http, this.rootUrl, params, context);
  }

  /**
   * get-restaurants-by-restaurantid-menus.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByRestaurantidMenus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByRestaurantidMenus(params: GetByRestaurantidMenus$Params, context?: HttpContext): Observable<GetRestaurantMenusResult> {
    return this.getByRestaurantidMenus$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetRestaurantMenusResult>): GetRestaurantMenusResult => r.body),
    );
  }

  /** Path part for operation `getRestaurants()` */
  static readonly GetRestaurantsPath = '/Restaurants';

  /**
   * get-restaurants.
   *
   * Get restaurants<br>Get restaurants for a given site
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRestaurants()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRestaurants$Response(params: GetRestaurants$Params, context?: HttpContext): Observable<StrictHttpResponse<GetRestaurantsResult>> {
    return getRestaurants(this.http, this.rootUrl, params, context);
  }

  /**
   * get-restaurants.
   *
   * Get restaurants<br>Get restaurants for a given site
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRestaurants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRestaurants(params: GetRestaurants$Params, context?: HttpContext): Observable<GetRestaurantsResult> {
    return this.getRestaurants$Response(params, context).pipe(map((r: StrictHttpResponse<GetRestaurantsResult>): GetRestaurantsResult => r.body));
  }

  /** Path part for operation `patchRestaurantsDishByDishidLikes()` */
  static readonly PatchRestaurantsDishByDishidLikesPath = '/Restaurants/dish/{DishId}/likes';

  /**
   * patch-restaurants-dish-by-dishid-likes.
   *
   * Update Dish likes<br>
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchDishByDishidLikes()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchDishByDishidLikes$Response(params: PatchDishByDishidLikes$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchDishByDishidLikes(this.http, this.rootUrl, params, context);
  }

  /**
   * patch-restaurants-dish-by-dishid-likes.
   *
   * Update Dish likes<br>
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchDishByDishidLikes$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchDishByDishidLikes(params: PatchDishByDishidLikes$Params, context?: HttpContext): Observable<void> {
    return this.patchDishByDishidLikes$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
